/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 28/6/2021
 * @Example
 */

export const types = {
    W05F0009_GET_CBO_EMPLOYEE: 'W05F0008_GET_CBO_EMPLOYEE',
    W05F0009_GET_CBO_CUSTOMER: 'W05F0009_GET_CBO_CUSTOMER',
    W05F0009_GET_CBO_DELIVERY_METHOD: 'W05F0009_GET_CBO_DELIVERY_METHOD',
    W05F0009_GET_CBO_PORTS: 'W05F0009_GET_CBO_PORTS',
    W05F0009_GET_CBO_PAYMENT_METHOD: 'W05F0009_GET_CBO_PAYMENT_METHOD',
    W05F0009_GET_CBO_BANKS: 'W05F0009_GET_CBO_BANKS',
    W05F0009_GET_MASTER_SUPPLEMENT: 'W05F0009_GET_MASTER_SUPPLEMENT',
    W05F0009_GET_DETAIL_SUPPLEMENT: 'W05F0009_GET_DETAIL_SUPPLEMENT',
    W05F0009_GET_CBO_UNIT: 'W05F0009_GET_CBO_UNIT',
    W05F0009_GET_CBO_MARKING: 'W05F0009_GET_CBO_MARKING',
    W05F0009_GET_CBO_PACKING_METHOD: 'W05F0009_GET_CBO_PACKING_METHOD',
    W05F0009_GET_CBO_PACKING_TYPE: 'W05F0009_GET_CBO_PACKING_TYPE',
    W05F0009_GET_CBO_PAYMENT_TERM: 'W05F0009_GET_CBO_PAYMENT_TERM',
    W05F0009_GET_DECIMAL_QUANTITY: 'W05F0009_GET_DECIMAL_QUANTITY',
    W05F0009_LOAD_FORM: 'W05F0009_LOAD_FORM',
    W05F0009_GET_CBO_TYPE_APPENDIX: 'W05F0009_GET_CBO_TYPE_APPENDIX',
    W05F0009_SUBCONTRACTNO: 'W05F0009_SUBCONTRACTNO',
    W05F0009_CHECK_SUBCONTRACTNO: 'W05F0009_CHECK_SUBCONTRACTNO',
    W05F0009_SAVE: 'W05F0009_SAVE',
    W05F0009_EDIT: 'W05F0009_EDIT',
    W05F0009_GET_DATA_DISPLAY: 'W05F0009_GET_DATA_DISPLAY',
    W05F0009_GET_QUANTITY_DEPLOY: 'W05F0009_GET_QUANTITY_DEPLOY'

}


export function getCbEmployees(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_EMPLOYEE,
        params,
        cb
    }
}

export function getCbCustomer(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_CUSTOMER,
        params,
        cb
    }
}

export function getCboDeliveryMethod(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_DELIVERY_METHOD,
        params,
        cb
    }
}

export function getCboPorts(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_PORTS,
        params,
        cb
    }
}

export function getCboPaymentMenthod(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_PAYMENT_METHOD,
        params,
        cb
    }
}

export function getCboBanks(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_BANKS,
        params,
        cb
    }
}

export function getMasterSupplement(params, cb) {
    return {
        type: types.W05F0009_GET_MASTER_SUPPLEMENT,
        params,
        cb
    }
}

export function getDetailSupplement(params, cb) {
    return {
        type: types.W05F0009_GET_DETAIL_SUPPLEMENT,
        params,
        cb
    }
}

export function getCboUnit(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_UNIT,
        params,
        cb
    }
}

export function getCboMarking(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_MARKING,
        params,
        cb
    }
}

export function getCboPackingMethod(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_PACKING_METHOD,
        params,
        cb
    }
}

export function getCboPackingType(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_PACKING_TYPE,
        params,
        cb
    }
}

export function getCboPaymentTerm(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_PAYMENT_TERM,
        params,
        cb
    }
}

export function getDecimalQuantity(params, cb) {
    return {
        type: types.W05F0009_GET_DECIMAL_QUANTITY,
        params,
        cb
    }
}

export function loadForm(params, cb) {
    return {
        type: types.W05F0009_LOAD_FORM,
        params,
        cb
    }
}

export function getCboTypeAppendix(params, cb) {
    return {
        type: types.W05F0009_GET_CBO_TYPE_APPENDIX,
        params,
        cb
    }
}

export function subContractNo(params, cb) {
    return {
        type: types.W05F0009_SUBCONTRACTNO,
        params,
        cb
    }
}

export function checkSubContractNo(params, cb) {
    return {
        type: types.W05F0009_CHECK_SUBCONTRACTNO,
        params,
        cb
    }
}

export function onSave(params, cb) {
    return {
        type: types.W05F0009_SAVE,
        params,
        cb
    }
}

export function onEdit(params, cb) {
    return {
        type: types.W05F0009_EDIT,
        params,
        cb
    }
}

export function getDataDisplay(params, cb) {
    return {
        type: types.W05F0009_GET_DATA_DISPLAY,
        params,
        cb
    }
}

export function getQuantityDeploy(params, cb) {
    return {
        type: types.W05F0009_GET_QUANTITY_DEPLOY,
        params,
        cb
    }
}
